import { requestApi } from '../util/network'

// 获取店铺门店列表
export const getChainList =
    (data, params) =>
      requestApi(
        '/seller_chain/index',
        'POST',
        Object.assign(data, params),
        'seller'
      )

// 获取店铺配送信息
export const getChainInfo =
    (data) =>
      requestApi(
        '/seller_chain/info',
        'POST',
        data,
        'seller'
      )

// 新增发票
export const addChain =
    (data) =>
      requestApi(
        '/seller_chain/add',
        'POST',
        data,
        'seller'
      )
// 编辑门店
export const editChain =
    (data) =>
      requestApi(
        '/seller_chain/edit',
        'POST',
        data,
        'seller'
      )
// 删除门店
export const delChain =
    (data) =>
      requestApi(
        '/seller_chain/del',
        'POST',
        data,
        'seller'
      )
